import { computed } from 'vue';
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';
import { useApi } from '@shopexperts/shared';
import { useAuthStore } from '@/store/auth';

export function useReviewShareBackgrounds() {
    const clientApi = useApi();
    const api = clientApi.expert.reviewShareBackgrounds;
    const auth = useAuthStore();
    const client = useQueryClient();
    const queryKey = computed(() => ['expert', 'review-share-backgrounds', auth.user?.id]);
    const query = useQuery({ queryKey, queryFn: () => api.list() });
    const refresh = () => client.invalidateQueries({ queryKey: queryKey.value });
    const upload = useMutation({
        mutationFn: async (file: File) => {
            const media = await clientApi.media.upload({ file, collection: 'review_share_background' });
            return api.save(media.id);
        },
        onSuccess: refresh,
    });
    const remove = useMutation({
        mutationFn: (id: string | number) => api.delete({ params: { id } }),
        onSuccess: refresh,
    });
    const backgrounds = computed(() => query.data.value?.data ?? []);
    const limit = computed(() => Math.max(0, query.data.value?.limit ?? 0));
    const uploadCount = computed(() => backgrounds.value.filter(item => !item.is_preset).length);

    return { ...query, backgrounds, limit, uploadCount, upload, remove };
}
